import React from 'react';
import { observer } from 'mobx-react-lite';

import { Separator } from '../../common/Separator';
import { FlatList, IFlatListProps } from '../../common/FlatList';
import { Category } from '@models/Tutorials/CategoryModel';
import {
  FilterSectionItem,
  IFilterSectionItemProps,
} from './FilterSectionItem';

interface IFiltersProps
  extends Omit<
      IFlatListProps<Category>,
      'renderItem' | 'keyExtractor' | 'data'
    >,
    Pick<
      IFilterSectionItemProps,
      'onChangeValue' | 'withPreSelection'
    > {
  data: Category[];
}

export const Filters = observer<IFiltersProps>((props) => {
  return (
    <FlatList
      keyExtractor={(i) => i.id.toString()}
      renderItem={({ item }) => (
        <FilterSectionItem
          item={item}
          onChangeValue={props.onChangeValue}
          withPreSelection={props.withPreSelection}
        />
      )}
      ItemSeparatorComponent={() => <Separator size="$7" />}
      {...props}
    />
  );
});
